class FaqGroup extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('.faq-item');
    this.items.forEach((item) => {
      item.querySelector('.faq-item__question').addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(item) {
    const isOpen = item.classList.contains('is-open');

    this.items.forEach((i) => {
      i.classList.remove('is-open');
      i.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
      i.querySelector('.faq-item__answer').style.maxHeight = '0';
    });

    if (!isOpen) {
      item.classList.add('is-open');
      item.querySelector('.faq-item__question').setAttribute('aria-expanded', 'true');
      const answer = item.querySelector('.faq-item__answer');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  }
}

customElements.define('faq-group', FaqGroup);
